<template>
  <Block class="activity-time" title="惊喜彩蛋">
    <div class="content">
      <template v-if="isLargeScreen === true">
        <VueLazyImg classStyle="act-img"
          src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/52822523-7fdf-40dd-ac9d-eb738d063a1e.png" />
      </template>
      <template v-if="isLargeScreen === false">
        <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/supr11.png" />
        <VueLazyImg classStyle="act-img" src="https://p4-ky.wsukwai.com/udata/pkg/KMOVIE-CDN/image/supr22.png" />
      </template>
    </div>
  </Block>
</template>
<script setup lang="ts">
import Block from "./common/block.vue";
import useDevice from "./common/useDevice";

// const { isLargeScreen } = useDevice();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})
</script>

<style scoped lang="less">
.activity-time {
  margin-bottom: 2.8rem;

  @media screen and(max-width: 1360px) {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.content {
  width: 100%;
  margin-top: 0.8rem;

  .act-img {
    width: 100%;
  }
}
</style>
